module.exports = __webpack_public_path__ + "static/media/under_control_-_2.ba8d1d0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/incident_layer/under_control_-_2.png
// module id = 375
// module chunks = 0